export class AppDatatableCellFocusEvent {
    public event: any;
    public row: any;
    public column: any;
    public rowIndex: number;

    constructor(event: any, row: any, column: any, rowIndex: number) {
        this.event = event;
        this.row = row;
        this.column = column;
        this.rowIndex = rowIndex;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/datatable/models/cell-focus-event.model.ts